import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@tsin-env/environment';
import { IInvoice, IInvoiceCreate, IInvoiceQueryParams } from '@tsin-core/models/invoice.model';

const INVOICE_URL = `${environment.paymentApiUrl}/payment/invoices`;
const PAYMENTS_URL = `${environment.paymentApiUrl}/payment`;

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(private http: HttpClient) { }

  /**
   * Get invoices with optional query parameters
   * GET /api/payment/invoices
   */
  getInvoices(params?: IInvoiceQueryParams): Observable<IInvoice[]> {
    return this.http.get<IInvoice[]>(INVOICE_URL, { params: params as any });
  }

  /**
   * Get invoice by application ID
   * GET /api/payment/invoices/application/{applicationId}
   */
  getInvoiceByApplicationId(applicationId: string): Observable<IInvoice> {
    return this.http.get<IInvoice>(`${INVOICE_URL}/application/${applicationId}`);
  }

  /**
   * Get invoices by exam type
   * GET /api/payment/invoices/exam/{examType}
   */
  getInvoicesByExamType(examType: string): Observable<IInvoice[]> {
    return this.http.get<IInvoice[]>(`${INVOICE_URL}/exam/${examType}`);
  }

  /**
   * Get single invoice by ID
   * GET /api/payment/invoices/single/{invoiceId}
   */
  getInvoiceById(invoiceId: string): Observable<IInvoice> {
    return this.http.get<IInvoice>(`${INVOICE_URL}/single/${invoiceId}`);
  }

  /**
   * Get invoices by user ID
   * GET /api/payment/invoices/user/{userId}
   */
  getInvoicesByUserId(userId: string): Observable<IInvoice[]> {
    return this.http.get<IInvoice[]>(`${INVOICE_URL}/user/${userId}`);
  }

  /**
   * Create a new invoice
   * POST /api/payment/invoices
   */
  createInvoice(invoice: IInvoiceCreate): Observable<IInvoice> {
    return this.http.post<{ invoice: IInvoice }>(INVOICE_URL, invoice).pipe(
      map(response => response.invoice)
    );
  }

  /**
   * Query payments by examType
   * Get /api/payment?examType={examType}
   */
  getPaymentByExamType(examType: string): Observable<any> {
    return this.http.get<any>(PAYMENTS_URL, { params: { examType } });
  }
}
